export default {
    root: {
        class: 'flex items-center gap-3.5 group-hover:gap-6 transition-all',
    },
};
